/**
 * Project Viewer Guard
 *
 * Allows all authenticated users to view project admin pages.
 * This is for documentation/transparency purposes (UNE166006 compliance).
 *
 * Edit permissions are still controlled by analyst flag at component level.
 */

import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthStore } from '@app/core/auth/stores/auth-store';
import { devLog, devWarn } from '@app/core/utils/dev-logger';

export const projectViewerGuard: CanActivateFn = () => {
  let authStore: AuthStore;
  let router: Router;

  try {
    authStore = inject(AuthStore);
    router = inject(Router);
  } catch (error) {
    // If injection fails during initialization, redirect to login
    const fallbackRouter = inject(Router);
    return fallbackRouter.createUrlTree(['/login']);
  }

  // Check if user is authenticated - that's all we need for project viewing
  if (!authStore.isLoggedIn()) {
    devWarn('Access denied: User not authenticated');
    return router.createUrlTree(['/login']);
  }

  devLog('✓ Project viewer guard: Access granted');
  return true;
};
